exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".external-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.external-group .private-conflict-icon {\n  margin-left: 24px;\n}\n", ""]);

// exports
